import actionTypes from '../../../redux/actions/action-types';

export const getChartsAction = (data) => ({
  type: actionTypes.chartsPage.getCharts,
  data
});

export const getTeamIdAction = (data) => ({
  type: actionTypes.chartsPage.getTeamId,
  data
});

export const updateProjectAction = (data) => ({
  type: actionTypes.chartsPage.updateChart,
  data
});

export const pageUpdateAction = (data) => ({
  type: actionTypes.chartsPage.pageUpdate,
  data
});

export const getTagsAction = (data) => ({
  type: actionTypes.chartsPage.getTags,
  data
});

export const setSelectFilterAction = (data) => ({
  type: actionTypes.chartsPage.setSelectFilter,
  data
});

export const getCreatorsAction = (data) => ({
  type: actionTypes.chartsPage.getCreators,
  data
});

export const setAction = (data) => ({
  type: actionTypes.chartsPage.set,
  data
});
